
const ParentsSupportFaith = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[550px] flex items-center justify-center"
        style={{
          backgroundImage: "url('./images/parents-support.png')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            How Parents Can Support Their Children’s Faith at Home
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            Practical ways for parents to nurture faith, values, and a personal relationship with God in the family.
          </p>
        </div>
      </div>

      <section className="body--container w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            In today’s busy world, raising children in faith requires intentionality and dedication. While Sunday School and church activities
            play a significant role, parents remain the most influential spiritual teachers in their children’s lives.
          </p>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              1. Model Faith Through Daily Actions
            </h2>
            <p>
              Children learn more from what they see than what they are told. Pray openly, read Scripture together, and demonstrate kindness,
              patience, and integrity in daily life. Faith becomes tangible when children see it lived authentically.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              2. Create a Consistent Spiritual Routine
            </h2>
            <p>
              Establishing simple, consistent routines helps children internalize spiritual practices: family devotionals, prayer at mealtimes,
              and reflections on church or Sunday School lessons reinforce meaningful spiritual habits.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              3. Encourage Questions and Exploration
            </h2>
            <p>
              Nurture children’s curiosity by responding thoughtfully to questions, exploring Scripture together, and fostering open discussions
              about beliefs and moral decisions.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              4. Engage in Shared Worship and Activities
            </h2>
            <p>
              Attend church services together, participate in service projects, and involve children in Sunday School activities. Shared experiences
              help them see faith in action and strengthen family bonds.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              5. Celebrate Spiritual Milestones
            </h2>
            <p>
              Recognize achievements in faith—learning a Bible verse, acts of kindness, baptisms, or confirmations. Celebrating milestones reinforces
              joy and encourages continued spiritual growth.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              6. Provide a Supportive and Loving Environment
            </h2>
            <p>
              Listen attentively, encourage honesty, compassion, and forgiveness, and model grace in family interactions. A loving, spiritually safe
              home allows children to trust in God and flourish.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              7. Encourage Personal Prayer and Reflection
            </h2>
            <p>
              Guide children to pray independently, reflect on faith, and journal or draw spiritual thoughts. Personal prayer strengthens their
              relationship with God and builds spiritual resilience.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              Conclusion: Nurturing Faith at Home
            </h2>
            <p>
              Parents are the most influential spiritual mentors. By modeling faith, establishing routines, encouraging exploration, and fostering
              love, parents create a home where faith grows strong. Supporting children’s spiritual development ensures lessons from Sunday School
              take root and flourish for a lifetime.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Parenting</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Faith at Home</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Spiritual Growth</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Sunday School</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ParentsSupportFaith;